import React, { useState, useContext, useEffect, useRef } from 'react';
import Application from "../../../StateContext/Application";
import { Form } from 'react-router-dom';

const CreateRoles = () => {
  const [roleName, setRoleName] = useState({
    Department_ID: "",
    Rolename: ''
  });
  const [options, setOptions] = useState([]);
  const [show, setshow] = useState(true)
  const [DepartmentList, SetDepartment] = useState([])
  const [menu, setmenu] = useState({})
  const statecalls = useContext(Application);
  const { Usermenu, Roles, DepartmentHandler } = statecalls;
  const formdataref = useRef(null)
  const [expandedMenuId, setExpandedMenuId] = useState(null); 

  useEffect(() => {
    async function getmenus() {
      try {
        let menu = await Usermenu();
        let department = await DepartmentHandler('view', null, null);
        SetDepartment(department);
        setOptions(menu.result || []);
      } catch (error) {
        console.error(error);
      }
    }
    getmenus()
  }, [])

  async function objectpusher(menuname, access) {
    try {
      const updatedMenu = { ...menu };
      if (!Array.isArray(updatedMenu[menuname])) {
        updatedMenu[menuname] = [access];
      } else {
        updatedMenu[menuname] = [...updatedMenu[menuname], access];
      }
      setmenu(updatedMenu);
      console.log(updatedMenu);
    } catch (error) {
      console.error(error);
    }
  }

  const rolecreation = async () => {
    try {
      alert("Role Created Successfully")
      let condition = await Roles('CreateRole', roleName, menu);
      setshow(condition);
      window.location.reload()
    } catch (error) {
      console.error(error);
    }
  }

  const resetData = () => {
    formdataref.current.reset()
    setRoleName([])
  }

  const toggleMenu = (menuId) => {
    setExpandedMenuId(expandedMenuId === menuId ? null : menuId);
  };

  return (
    <div style={{backgroundColor:'#f4f7fe', overflowY: 'auto', maxHeight: '91vh', height: '94vh'}}>
      <Form onSubmit={rolecreation} style={{ padding: '20px' }} ref={formdataref}>
        <div style={{ display: 'grid', gap: "15px" }}>
          <div style={{ marginTop: 20, display: 'grid', gap: '2rem', border: 'none', boxShadow: '0px 0px 2px', padding: '30px', backgroundColor: 'white', borderRadius: '10px', flexWrap: "wrap" }}>
            <div style={{ display: 'flex', alignItems: 'center', padding: '10px' }}>
              <div style={{ display: 'flex', alignItems: 'center' }} className="col-6">
                <label className='form-label col-4' style={{ fontWeight: '700' }}>Select Department</label>
                <select
                  className="form-control"
                  id='Department_ID'
                  onChange={(e) => { setRoleName({ ...roleName, [e.target.id]: e.target.value }) }}
                >
                  <option>Select Department</option>
                  {DepartmentList.map((e) => {
                    return (
                      <option key={e.Department_ID} value={e.Department_ID}>
                        {e.Department_Name}
                      </option>
                    )
                  })}
                </select>
              </div>
              <div style={{ display: 'flex' }} className="col-6">
                <label className='form-label col-4' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: '700' }}>Role Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Role Name Here"
                  id='Rolename'
                  value={roleName.Rolename}
                  onChange={(e) => { setRoleName({ ...roleName, [e.target.id]: e.target.value }) }}
                  required
                />
              </div>
            </div>
          </div>

          <div>
            {show ? options.map((e, key) => {
              if (e.Summenuid === 0) {
                return (
                  <>
                    <div key={key} className="accordion" id="accordionPanelsStayOpenExample" style={{ padding: 10, border: "3px solid lightgray", borderRadius: 7, backgroundColor: 'white' }}>
                      <div className="accordion-item" style={{ border: 'none' }} >
                        <h2 className="accordion-header" id={`heading-${e.Menu_ID}`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'end', backgroundColor: 'lightgray', borderRadius: '5px 5px 0px 0px', height: '2.5rem', border: '1px solid darkgray' }}>
                          <button
                            type="button"
                            onClick={() => toggleMenu(e.Menu_ID)}
                            style={{ display: 'flex', fontSize: '15px', color: '#052c65' }}
                          >
                            {e.Menu_Name} {expandedMenuId === e.Menu_ID ? "▼" : "▶"}
                          </button>
                        </h2>
                        <div >
                        <div style={{ backgroundColor: "#c8e5fc", display: "flex", justifyContent: "space-between", fontWeight: 600, marginTop: 10, padding: 10, border: '1px solid black' }}>
                          <b>{e.Menu_Name}</b>
                          <div style={{ display: 'flex' }}>
                            <span className='mx-2' style={{ display: 'flex', gap: '5px' }}><b>Create</b><input type='checkbox' onClick={() => objectpusher(e.Menu_ID, 'create')} /></span>
                            <span className='mx-2' style={{ display: 'flex', gap: '5px' }}><b>Read</b><input type='checkbox' onClick={() => objectpusher(e.Menu_ID, 'Read')} /></span>
                            <span className='mx-2' style={{ display: 'flex', gap: '5px' }}><b>Edit</b><input type='checkbox' onClick={() => objectpusher(e.Menu_ID, 'Edit')} /></span>
                            <span className='mx-2' style={{ display: 'flex', gap: '5px' }}><b>Delete</b><input type='checkbox' onClick={() => objectpusher(e.Menu_ID, 'Delete')} /></span>
                          </div>
                        </div>
                        <div id={`collapse-${e.Menu_ID}`} className={`accordion-collapse collapse ${expandedMenuId === e.Menu_ID ? "show" : ""}`} aria-labelledby={`heading-${e.Menu_ID}`}>
                        <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
                          <div className="accordion-body">
                            {options.map((x, index) => {
                              if (e.Menu_ID === x.Summenuid) {
                                return (
                                  <div key={index} style={{ display: 'flex', justifyContent: 'space-between', height: '2.5rem', alignItems: 'end', borderBottom: '1px solid black', padding: '0px 10px' }}>
                                    <label> {x.Menu_Name}</label>
                                    <div style={{ display: 'flex' }}>
                                      <span className='mx-2'><b>Create</b> <input type='checkbox' onClick={() => objectpusher(x.Menu_ID, 'create')} /></span>
                                      <span className='mx-2'><b>Read</b> <input type='checkbox' onClick={() => objectpusher(x.Menu_ID, 'Read')} /></span>
                                      <span className='mx-2'><b>Edit</b> <input type='checkbox' onClick={() => objectpusher(x.Menu_ID, 'Edit')} /></span>
                                      <span className='mx-2'><b>Delete</b> <input type='checkbox' onClick={() => objectpusher(x.Menu_ID, 'Delete')} /></span>
                                    </div>
                                  </div>
                                )
                              }

                            })}


                          </div>
                        </div>
                        </div>
                        </div>
                      </div>
                    </div>
                    <br />
                  </>
                )
              }
            }) : null}
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button type="submit" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: '#502eff', border: 'none', fontSize: '17px', gap: '4px' }}>Create Role </button>
            <button onClick={resetData} type='button' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: 'red', border: 'none', fontSize: '17px', gap: '4px' }}> Reset</button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default CreateRoles;
